enum FLUX_AUTH_CONSTANTS {
    LOGIN_BEGIN = "LOGIN_BEGIN",
    LOGIN_ERROR = "LOGIN_ERROR",
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGOUT_BEGIN = "LOGOUT_BEGIN",
    LOGOUT_ERROR = "LOGOUT_ERROR",
    LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
    SIGNUP_BEGIN = "SIGNUP_BEGIN",
    SIGNUP_ERROR = "SIGNUP_ERROR",
    SIGNUP_SUCCESS = "SIGNUP_SUCCESS",
    BACK_WHEN_LOGIN = "BACK_WHEN_LOGIN",
    CLEAR_AUTH_LOADING = "CLEAR_AUTH_LOADING",
    EDIT_INFO ='EDIT',
    EDIT_INFO_ERROR = 'EDIT_INFO_ERROR',
    EDIT_INFO_BEGIN = 'EDIT_INFOR_BEGIN'
}

export default FLUX_AUTH_CONSTANTS